import Navbar from "../Components/Navbar";
import Home from "../Components/Home";
import Coutrallam from "../Components/Coutralam";
import Attractions from "../Components/Attractions";
import Footer from "../Components/Footer";

function HomePage() {
  return (
    <>
      <Navbar />
      <Home />
      <Coutrallam />
      <Attractions />
      <Footer />


    </>
  );
}

export default HomePage;